//---------------------------------
// get specific rune casting skill
//---------------------------------
export default function getSpecificRuneCastingSkill({ skills, target_rune }) {
  if (!skills || !target_rune) {
    console.error('getSpecificRuneCastingSkill: missing required parms')
    return 0
  }

  const runeFamilyName =
    target_rune?.name ?? target_rune?.rune_name ?? target_rune?.display_name ?? ''

  return skills.find((s) => s.name == 'Runecasting' && s.display_name == runeFamilyName)
}
